import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS } from './image-preview-icon-action.types';

@Component({
  selector: 'common-image-preview-icon-action',
  templateUrl: './image-preview-icon-action.component.html',
  styleUrls: ['./image-preview-icon-action.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagePreviewIconActionComponent {
  @Input() imageUrl: string | undefined = MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS.imageUrl;
  @Input() icon: string | undefined = MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS.icon;
  @Input() iconSet: string = MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS.iconSet;
  @Input() alt = MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS.alt;
  @Input() disabled = MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS.disabled;
  @Input() size: 'small' | 'large' = MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS.size;
  /** Marca visual tipo "selected" + check_circle (ej. portada seleccionada). */
  @Input() selected: boolean = false;

  /** Ligature del `common-icon-button` (p. ej. edit, more_vert). */
  @Input() actionIcon = MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS.actionIcon;
  /** Texto accesible del botón de acción. */
  @Input() actionAriaLabel = MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS.actionAriaLabel;

  @Input() showReplaceOption: boolean = MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS.showReplaceOption;
  @Input() showSetCoverOption: boolean = MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS.showSetCoverOption;
  @Input() showDeleteOption: boolean = MUNILY_IMAGE_PREVIEW_ICON_ACTION_DEFAULTS.showDeleteOption;

  @Output() action = new EventEmitter<void>();
  @Output() menuAction = new EventEmitter<'replace' | 'setCover' | 'delete'>();

  constructor(private readonly sanitizer: DomSanitizer) {}

  get hasImage(): boolean {
    return !!this.imageUrl?.trim();
  }

  get hasIcon(): boolean {
    return !this.hasImage && !!this.icon?.trim();
  }

  get safeImageSrc(): string | SafeUrl {
    const url = this.imageUrl;
    if (!url) {
      return '';
    }
    if (url.startsWith('blob:') || url.startsWith('data:')) {
      return this.sanitizer.bypassSecurityTrustUrl(url);
    }
    return url;
  }

  onAction(): void {
    if (!this.disabled) {
      this.action.emit();
    }
  }

  onMenuAction(action: 'replace' | 'setCover' | 'delete'): void {
    if (!this.disabled) {
      this.menuAction.emit(action);
    }
  }
}
